// extracted by mini-css-extract-plugin
module.exports = {"link":"_1_kc0","root":"_22oPj","label":"_3fUtn"};